import { render, staticRenderFns } from "./PreviewCode.vue?vue&type=template&id=afc6a5f4&scoped=true&"
import script from "./PreviewCode.vue?vue&type=script&lang=js&"
export * from "./PreviewCode.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCode.vue?vue&type=style&index=0&id=afc6a5f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc6a5f4",
  null
  
)

export default component.exports